/**
 * inspired by jdduke (http://jsbin.com/qofuwa/2/edit)
 */

export default {
    mounted() {
        var preventPullToRefresh = (function preventPullToRefresh(lastTouchY) {
            lastTouchY = lastTouchY || 0;
            var maybePrevent = false;

            function setTouchStartPoint(event) {
                lastTouchY = event.touches[0].clientY;
            }
            function isScrollingUp(event) {
                var touchY = event.touches[0].clientY,
                    touchYDelta = touchY - lastTouchY;

                lastTouchY = touchY;

                // if touchYDelta is positive -> scroll up
                if (touchYDelta > 0) {
                    return true;
                } else {
                    return false;
                }
            }

            return {
                // set touch start point and check whether here is offset top 0
                touchstartHandler: function (event) {
                    if (event.touches.length != 1) return;
                    setTouchStartPoint(event);
                    maybePrevent = window.pageYOffset === 0;
                },
                // reset maybePrevent frag and do prevent
                touchmoveHandler: function (event) {
                    if (maybePrevent) {
                        maybePrevent = false;
                        if (isScrollingUp(event)) {
                            event.preventDefault();
                            return;
                        }
                    }
                }
            }
        })();

        // usage
        document.addEventListener('touchstart', preventPullToRefresh.touchstartHandler);
        document.addEventListener('touchmove', preventPullToRefresh.touchmoveHandler);
    }
}




// WEBPACK FOOTER //
// ./src/mixins/preventPullToRefresh.js